// 平台通用-投放数据
export const plat_common_index = [
  {
    title: "新建计划数",
    width: 100,
    sort_status: 0,
    type: "new_plan_count",
    text_right: true,
    sort_control: true,
    show_control: true,
  },

  {
    title: "有消耗的计划数",
    width: 130,
    sort_status: 0,
    type: "cost_plan_count",
    text_right: true,
    sort_control: true,
    show_control: true,
  },
  {
    title: "总消耗",
    width: 100,
    sort_status: 0,
    type: "cost",
    text_right: true,
    sort_control: true,
    show_control: true,
  },
  {
    title: "平均单计划消耗",
    width: 140,
    sort_status: 0,
    type: "avg_plan_cost",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "展示数",
    width: 100,
    sort_status: 0,
    type: "show",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "ecpm",
    width: 100,
    sort_status: 0,
    type: "avg_show_cost",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "点击数",
    width: 100,
    sort_status: 0,
    type: "click",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "平均点击单价",
    width: 120,
    sort_status: 0,
    type: "avg_click_cost",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "点击率(%)",
    width: 100,
    sort_status: 0,
    type: "ctr",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
];
// 综合ROI指标
export const all_roi_index = [
  {
    title: "当天综合收入",
    width: 100,
    sort_status: 0,
    type: "eff_agg_revenue_d0",
    text_right: false,
    sort_control: false,
    show_control: false,
  },
  {
    title: "当天综合分成收入",
    width: 140,
    sort_status: 0,
    type: "eff_agg_left_revenue_d0",
    text_right: false,
    sort_control: false,
    show_control: true,
  },
  {
    title: "当天综合ROI",
    width: 120,
    sort_status: 0,
    type: "eff_agg_roi_d0",
    text_right: false,
    sort_control: false,
    show_control: true,
  },
];
//  巨量平台指标
export const jl_platform_index = [
  {
    title: "巨量-激活数",
    width: 120,
    sort_status: 0,
    type: "active",
    text_right: true,
    sort_control: true,
    show_control: true,
  },

  {
    title: "巨量-激活成本",
    width: 120,
    sort_status: 0,
    type: "active_cost",
    text_right: true,
    sort_control: true,
    show_control: true,
  },
  {
    title: "巨量-转化数",
    width: 120,
    sort_status: 0,
    type: "convert",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "巨量-平均转化成本",
    width: 150,
    sort_status: 0,
    type: "convert_cost",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "巨量-转化率(%)",
    width: 130,
    sort_status: 0,
    type: "convert_rate",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "巨量-关键行为数",
    width: 140,
    sort_status: 0,
    type: "game_addiction",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "巨量-关键行为成本",
    width: 150,
    sort_status: 0,
    type: "game_addiction_cost",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "巨量-关键行为率",
    width: 140,
    sort_status: 0,
    type: "game_addiction_rate",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "巨量-小程序激活后七日LTV",
    width: 120,
    sort_status: 0,
    type: "attribution_micro_game_7d_ltv",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "巨量-小程序激活后七日广告变现ROI",
    width: 160,
    sort_status: 0,
    type: "attribution_micro_game_7d_roi",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
];

// 巨量-IAA指标（基于巨量平台指标）
export const jl_iaa_index = [
  {
    title: "小程序激活后七日净LTV",
    width: 100,
    sort_status: 0,
    type: "eff_attribution_micro_game_7d_ltv_net",
    text_right: false,
    sort_control: false,
    show_control: false,
  },
  {
    title: "小程序激活后七日净分成LTV",
    width: 120,
    sort_status: 0,
    type: "eff_attribution_micro_game_7d_ltv_net_left",
    text_right: false,
    sort_control: false,
    show_control: true,
  },
  {
    title: "小程序激活后七日广告变现净分成ROI",
    width: 150,
    sort_status: 0,
    type: "eff_attribution_micro_game_7d_ltv_net_left_roi",
    text_right: false,
    sort_control: false,
    show_control: true,
  },
];

//腾讯ADQ平台指标
export const tx_adq_index = [
  {
    title: "腾讯-公众号关注数(ADQ 非微信)",
    width: 150,
    sort_status: 0,
    type: "from_follow_uv",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "腾讯-公众号关注成本(ADQ 非微信)",
    width: 150,
    sort_status: 0,
    type: "from_follow_cost",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
];

// 百度平台指标
export const bd_platform_index = [
  {
    title: "百度-微信调起按钮点击量",
    width: 130,
    sort_status: 0,
    type: "weiXinAppButtonConversions",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "百度-微信调起按钮点击成本",
    width: 130,
    sort_status: 0,
    type: "weiXinAppButtonConversionsCost",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "百度-微信加粉成功量",
    width: 130,
    sort_status: 0,
    type: "weixinFollowSuccessConversions",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "百度-微信加粉成功成本",
    width: 130,
    sort_status: 0,
    type: "weixinFollowSuccessConversionsCost",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "百度-微信复制按钮点击量",
    width: 130,
    sort_status: 0,
    type: "weiXinCopyConversions",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "百度-微信复制按钮点击成本",
    width: 130,
    sort_status: 0,
    type: "weiXinCopyConversionsCost",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
];

// 快手平台指标：IAP+IAA
export const ks_ipa_index = [
  {
    title: "快手-激活数",
    width: 120,
    sort_status: 0,
    type: "activation",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "快手-激活单价",
    width: 120,
    sort_status: 0,
    type: "conversion_cost",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "快手-付费金额",
    width: 120,
    sort_status: 0,
    type: "event_pay_purchase_amount",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "快手-ROI",
    width: 100,
    sort_status: 0,
    type: "event_pay_roi",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "快手-激活后三日广告LTV",
    width: 120,
    sort_status: 0,
    type: "minigame_iaa_purchase_amount_three_day_by_conversion",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "快手-激活后三日广告变现ROI",
    width: 140,
    sort_status: 0,
    type: "minigame_iaa_purchase_amount_three_day_by_conversion_roi",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
];

//快手净收入指标（基于快手平台指标）
export const ks_platform_index = [
  {
    title: "快手-分成金额",
    width: 130,
    sort_status: 0,
    type: "eff_event_pay_purchase_amount_left",
    text_right: true,
    sort_control: true,
    show_control: true,
  },
  {
    title: "快手-分成ROI",
    width: 120,
    sort_status: 0,
    type: "eff_event_pay_roi_left",
    text_right: true,
    sort_control: true,
    show_control: true,
  },
  {
    title: "快手-激活后三日广告分成LTV",
    width: 140,
    sort_status: 0,
    type: "eff_iaa_purchase_amount_three_day_by_conversion_left",
    text_right: true,
    sort_control: true,
    show_control: true,
  },
  {
    title: "快手-激活后三日广告分成ROI",
    width: 140,
    sort_status: 0,
    type: "eff_iaa_purchase_amount_three_day_by_conversion_roi_left",
    text_right: true,
    sort_control: true,
    show_control: true,
  },
];

//飞碟统计数据项：付费ROI
export const fd_roi_index = [
  {
    title: "当天总充值金额",
    width: 140,
    sort_status: 0,
    type: "eff_total_pay_money",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "当天总分成金额",
    width: 140,
    sort_status: 0,
    type: "eff_total_left_money",
    text_right: true,
    sort_control: true,
    show_control: true,
  },
  {
    title: "当天付费ROI",
    width: 130,
    sort_status: 0,
    type: "eff_roi",
    text_right: true,
    sort_control: true,
    show_control: true,
  },
  {
    title: "当天订单笔数",
    width: 120,
    sort_status: 0,
    type: "eff_total_order_cnt",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "当天充值用户数",
    width: 140,
    sort_status: 0,
    type: "eff_total_pay_user_cnt",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "当天充值用户成本",
    width: 140,
    sort_status: 0,
    type: "eff_total_pay_user_cost",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "ARPU",
    width: 90,
    sort_status: 0,
    type: "eff_total_pay_user_arpu",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "当天首充分成金额",
    width: 150,
    sort_status: 0,
    type: "eff_total_left_money_fisrt",
    text_right: true,
    sort_control: true,
    show_control: true,
  },
  {
    title: "当天首充ROI",
    width: 120,
    sort_status: 0,
    type: "eff_roi_first",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "回传用户数",
    width: 100,
    sort_status: 0,
    type: "eff_report_pay_user_cnt",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
  {
    title: "回传用户成本",
    width: 120,
    sort_status: 0,
    type: "eff_report_pay_user_cost",
    text_right: true,
    sort_control: true,
    show_control: false,
  },
];

export const rableTitle = [
  ...plat_common_index,
  ...all_roi_index,
  ...jl_platform_index,
  ...jl_iaa_index,
  ...tx_adq_index,
  ...bd_platform_index,
  ...ks_ipa_index,
  ...ks_platform_index,
  ...fd_roi_index,
];

export const diyList = [
  {
    label: "平台通用-投放数据",
    showTitle: plat_common_index.map((v) => v.type),
    custom_checkbox: false,
    type: "plat_common_index",
  },
  {
    label: "综合ROI指标",
    showTitle: all_roi_index.map((v) => v.type),
    custom_checkbox: false,
    type: "all_roi_index",
  },
  {
    label: "巨量平台指标",
    showTitle: jl_platform_index.map((v) => v.type),
    custom_checkbox: false,
    type: "jl_platform_index",
  },
  {
    label: "巨量-IAA指标（基于巨量平台指标）",
    showTitle: jl_iaa_index.map((v) => v.type),
    custom_checkbox: false,
    type: "jl_iaa_index",
  },
  {
    label: "腾讯ADQ平台指标",
    showTitle: tx_adq_index.map((v) => v.type),
    custom_checkbox: false,
    type: "tx_adq_index",
  },
  {
    label: "百度平台指标",
    showTitle: bd_platform_index.map((v) => v.type),
    custom_checkbox: false,
    type: "bd_platform_index",
  },

  {
    label: "快手平台指标：IAP+IAA",
    showTitle: ks_ipa_index.map((v) => v.type),
    custom_checkbox: false,
    type: "ks_ipa_index",
  },

  {
    label: "快手净收入指标（基于快手平台指标）",
    showTitle: ks_platform_index.map((v) => v.type),
    custom_checkbox: true,
    type: "ks_platform_index",
  },
  {
    label: "飞碟统计数据项：付费ROI",
    showTitle: fd_roi_index.map((v) => v.type),
    custom_checkbox: false,
    type: "fd_roi_index",
  },
];

export const groupList = [
  {
    title: "投手名称",
    width: 90,
    sort_status: 0,
    type: "admin_id",
    text_right: false,
    sort_control: false,
    show_control: true,
  },
  {
    title: "推广日期",
    width: 90,
    sort_status: 0,
    type: "date_key",
    text_right: false,
    sort_control: false,
    show_control: true,
  },
  {
    title: "媒体平台",
    width: 90,
    sort_status: 0,
    type: "media_platform",
    text_right: false,
    sort_control: false,
    show_control: true,
  },
];

export const checkedList = ["admin_id", "date_key", "media_platform"];
export const checkedListArr = [
  {
    label: "推广日期",
    value: "date_key",
  },
  {
    label: "投手",
    value: "admin_id",
  },
  {
    label: "媒体平台",
    value: "media_platform",
  },
];

export const roiKeyList = [
  "eff_agg_roi_d0",
  "attribution_micro_game_7d_roi",
  "eff_attribution_micro_game_7d_ltv_net_left_roi",
  "event_pay_roi",
  "minigame_iaa_purchase_amount_three_day_by_conversion_roi",
  "eff_event_pay_roi_left",
  "eff_iaa_purchase_amount_three_day_by_conversion_roi_left",
  "eff_roi",
  "eff_roi_first",
];
